
export const neighborhoodCategories = [
  'All Neighborhoods',
  'Family-Friendly',
  'Luxury',
  'Active Adult',
  'New Development'
];

export const neighborhoods = [
  {
    id: 1,
    name: 'West Roseville',
    category: 'New Development',
    description: 'Roseville\'s newest master-planned community featuring modern homes, top-rated schools, and abundant parks and trails.',
    image: 'https://public.readdy.ai/ai/img_res/5beafdd8b69389d68a55e26f01e43966.jpg',
    priceRange: '$550K - $1.2M',
    avgPrice: '$725,000',
    homeTypes: ['Single Family', 'Townhomes'],
    schools: 'Roseville City School District',
    highlights: ['New Construction', 'Parks & Trails', 'Shopping Centers', 'Top Schools'],
    walkScore: 45,
    transitScore: 32
  },
  {
    id: 2,
    name: 'Granite Bay Adjacent',
    category: 'Luxury',
    description: 'Prestigious area bordering Granite Bay with estate homes, large lots, and proximity to Folsom Lake.',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20estate%20homes%20with%20large%20lots%2C%20manicured%20landscaping%2C%20Mediterranean%20architecture%2C%20gated%20community%20entrance%2C%20upscale%20California%20neighborhood&width=600&height=400&seq=re002&orientation=landscape',
    priceRange: '$900K - $2.5M',
    avgPrice: '$1,450,000',
    homeTypes: ['Estate Homes', 'Custom Builds'],
    schools: 'Eureka Union School District',
    highlights: ['Large Lots', 'Lake Access', 'Privacy', 'Custom Homes'],
    walkScore: 25,
    transitScore: 15
  },
  {
    id: 3,
    name: 'Sun City Roseville',
    category: 'Active Adult',
    description: 'Premier 55+ active adult community with golf course, fitness center, pools, and over 100 clubs and activities.',
    image: 'https://readdy.ai/api/search-image?query=Active%20adult%20retirement%20community%20with%20golf%20course%2C%20clubhouse%2C%20seniors%20playing%20golf%2C%20Mediterranean%20style%20homes%2C%20palm%20trees%2C%20resort-style%20amenities&width=600&height=400&seq=re003&orientation=landscape',
    priceRange: '$450K - $850K',
    avgPrice: '$595,000',
    homeTypes: ['Single Story', 'Patio Homes'],
    schools: 'N/A - 55+ Community',
    highlights: ['Golf Course', 'Clubhouse', '100+ Clubs', 'Resort Living'],
    walkScore: 35,
    transitScore: 28
  },
  {
    id: 4,
    name: 'Highland Reserve',
    category: 'Family-Friendly',
    description: 'Established family neighborhood with excellent schools, community parks, and convenient access to shopping.',
    image: 'https://readdy.ai/api/search-image?query=Family%20friendly%20suburban%20neighborhood%20with%20children%20playing%20in%20park%2C%20two-story%20homes%2C%20tree-lined%20streets%2C%20community%20playground%2C%20California%20suburb&width=600&height=400&seq=re004&orientation=landscape',
    priceRange: '$500K - $750K',
    avgPrice: '$625,000',
    homeTypes: ['Single Family', 'Two-Story'],
    schools: 'Dry Creek Joint Elementary',
    highlights: ['Great Schools', 'Community Parks', 'Family Events', 'Safe Streets'],
    walkScore: 42,
    transitScore: 30
  },
  {
    id: 5,
    name: 'Downtown Roseville',
    category: 'Family-Friendly',
    description: 'Historic downtown area with charming older homes, walkable streets, local shops, and vibrant community feel.',
    image: 'https://readdy.ai/api/search-image?query=Historic%20downtown%20neighborhood%20with%20craftsman%20style%20homes%2C%20tree-lined%20sidewalks%2C%20local%20shops%2C%20people%20walking%2C%20charming%20California%20small%20town%20feel&width=600&height=400&seq=re005&orientation=landscape',
    priceRange: '$400K - $700K',
    avgPrice: '$525,000',
    homeTypes: ['Craftsman', 'Victorian', 'Bungalows'],
    schools: 'Roseville City School District',
    highlights: ['Walkable', 'Historic Charm', 'Local Dining', 'Community Events'],
    walkScore: 72,
    transitScore: 45
  },
  {
    id: 6,
    name: 'Woodcreek',
    category: 'Family-Friendly',
    description: 'Popular family community with excellent schools, golf course, community pools, and extensive trail system.',
    image: 'https://readdy.ai/api/search-image?query=Upscale%20family%20neighborhood%20with%20golf%20course%20views%2C%20community%20pool%2C%20families%20biking%20on%20trails%2C%20well-maintained%20homes%2C%20California%20suburban%20living&width=600&height=400&seq=re006&orientation=landscape',
    priceRange: '$550K - $900K',
    avgPrice: '$695,000',
    homeTypes: ['Single Family', 'Executive Homes'],
    schools: 'Dry Creek Joint Elementary',
    highlights: ['Golf Course', 'Community Pools', 'Trail System', 'Top Schools'],
    walkScore: 38,
    transitScore: 25
  },
  {
    id: 7,
    name: 'Fiddyment Farm',
    category: 'New Development',
    description: 'Growing master-planned community with new homes, parks, schools, and family-friendly amenities.',
    image: 'https://readdy.ai/api/search-image?query=New%20master%20planned%20community%20with%20modern%20homes%20under%20construction%2C%20community%20park%2C%20young%20families%2C%20new%20school%20building%2C%20California%20new%20development&width=600&height=400&seq=re007&orientation=landscape',
    priceRange: '$500K - $850K',
    avgPrice: '$650,000',
    homeTypes: ['Single Family', 'New Construction'],
    schools: 'Roseville City School District',
    highlights: ['New Homes', 'Growing Community', 'Parks', 'New Schools'],
    walkScore: 35,
    transitScore: 22
  },
  {
    id: 8,
    name: 'Del Webb at Sun City',
    category: 'Active Adult',
    description: 'Award-winning Del Webb 55+ community with resort amenities, social clubs, and maintenance-free living.',
    image: 'https://readdy.ai/api/search-image?query=Del%20Webb%20active%20adult%20community%20with%20resort%20pool%2C%20seniors%20exercising%2C%20bocce%20ball%20courts%2C%20clubhouse%20activities%2C%20California%20retirement%20living&width=600&height=400&seq=re008&orientation=landscape',
    priceRange: '$400K - $750K',
    avgPrice: '$545,000',
    homeTypes: ['Single Story', 'Low Maintenance'],
    schools: 'N/A - 55+ Community',
    highlights: ['Resort Pool', 'Social Clubs', 'Fitness Center', 'Maintenance-Free'],
    walkScore: 32,
    transitScore: 25
  }
];

export const featuredListings = [
  {
    id: 1,
    address: '1234 Oak Valley Dr',
    neighborhood: 'West Roseville',
    price: 749000,
    beds: 4,
    baths: 3,
    sqft: 2450,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20modern%20California%20home%20exterior%2C%20two%20story%20house%20with%20three%20car%20garage%2C%20manicured%20front%20lawn%2C%20stone%20accents%2C%20blue%20sky%2C%20real%20estate%20photography&width=600&height=400&seq=listing001&orientation=landscape',
    status: 'For Sale',
    daysOnMarket: 5
  },
  {
    id: 2,
    address: '5678 Granite Ridge Ct',
    neighborhood: 'Granite Bay Adjacent',
    price: 1295000,
    beds: 5,
    baths: 4,
    sqft: 3800,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20estate%20home%20with%20Mediterranean%20architecture%2C%20large%20front%20yard%2C%20circular%20driveway%2C%20palm%20trees%2C%20upscale%20California%20real%20estate%20photography&width=600&height=400&seq=listing002&orientation=landscape',
    status: 'For Sale',
    daysOnMarket: 12
  },
  {
    id: 3,
    address: '910 Woodcreek Oaks Blvd',
    neighborhood: 'Woodcreek',
    price: 685000,
    beds: 4,
    baths: 2.5,
    sqft: 2200,
    image: 'https://readdy.ai/api/search-image?query=Charming%20family%20home%20with%20golf%20course%20view%2C%20well-maintained%20yard%2C%20covered%20patio%2C%20California%20suburban%20home%2C%20real%20estate%20listing%20photo&width=600&height=400&seq=listing003&orientation=landscape',
    status: 'For Sale',
    daysOnMarket: 8
  },
  {
    id: 4,
    address: '2468 Sun City Blvd',
    neighborhood: 'Sun City Roseville',
    price: 525000,
    beds: 2,
    baths: 2,
    sqft: 1650,
    image: 'https://readdy.ai/api/search-image?query=Single%20story%20retirement%20home%20with%20desert%20landscaping%2C%20tile%20roof%2C%20two%20car%20garage%2C%20active%20adult%20community%2C%20California%20real%20estate&width=600&height=400&seq=listing004&orientation=landscape',
    status: 'For Sale',
    daysOnMarket: 3
  },
  {
    id: 5,
    address: '3579 Highland Reserve Way',
    neighborhood: 'Highland Reserve',
    price: 599000,
    beds: 3,
    baths: 2,
    sqft: 1850,
    image: 'https://readdy.ai/api/search-image?query=Family%20home%20with%20large%20backyard%2C%20play%20structure%2C%20covered%20patio%2C%20two%20story%20California%20home%2C%20family%20friendly%20neighborhood&width=600&height=400&seq=listing005&orientation=landscape',
    status: 'Pending',
    daysOnMarket: 15
  },
  {
    id: 6,
    address: '789 Vernon Street',
    neighborhood: 'Downtown Roseville',
    price: 475000,
    beds: 3,
    baths: 2,
    sqft: 1400,
    image: 'https://readdy.ai/api/search-image?query=Charming%20craftsman%20bungalow%20with%20front%20porch%2C%20historic%20neighborhood%2C%20mature%20trees%2C%20walkable%20street%2C%20California%20historic%20home&width=600&height=400&seq=listing006&orientation=landscape',
    status: 'For Sale',
    daysOnMarket: 20
  }
];

export const marketStats = {
  medianPrice: 625000,
  priceChange: 4.2,
  avgDaysOnMarket: 18,
  inventoryCount: 245,
  soldLastMonth: 189,
  listToSaleRatio: 98.5
};
